//skills dictionary
export default {
    wordpress: {
      image: "images/icons/wordpress.png",
      name: "Wordpress",
      url: "https://wordpress.com"
    },
    react: {
      image: "images/icons/react.png",
      name: "React",
      url: "https://reactjs.org/"
    },
    twig: {
      image: "images/icons/twig.png",
      name: "Twig",
      url: "https://twig.symfony.com/"
    },
    js: {
      image: "images/icons/js.png",
      name: "JavaScript",
      url: "https://en.wikipedia.org/wiki/JavaScript"
    },
    bootstrap: {
      image: "images/icons/bootstrap.png",
      name: "Bootstrap",
      url: "https://getbootstrap.com/"
    },
    cordova: {
      image: "images/icons/cordova_128.png",
      name: "Cordova",
      url: "https://cordova.apache.org/"
    },
    html: {
      image: "images/icons/html.png",
      name: "HTML",
      url: "https://www.w3schools.com/html/"
    },
    css: {
      image: "images/icons/css.png",
      name: "CSS",
      url: "https://en.wikipedia.org/wiki/Cascading_Style_Sheets"
    },
    vue: {
      image: "images/icons/vue.png",
      name: "Vue",
      url: "https://vuejs.org/"
    },
    svelte:  {
      image: "images/icons/svelte.png",
      name: "Svelte",
      url: "https://svelte.dev/"
    },
    angular: {
      image: "images/icons/angular.png",
      name: "AngularJS",
      url: "https://angularjs.org/"
    },
    node: {
      image: "images/icons/node.png",
      name: "Node",
      url: "https://nodejs.org/en/"
    },
    sass: {
      image: "images/icons/sass.png",
      name: "SASS",
      url: "https://sass-lang.com/"
    },
    webpack: {
      image: "images/icons/webpack.png",
      name: "Webpack",
      url: "https://webpack.js.org/"
    },
    rollup: {
      image: "images/icons/rollup.png",
      name: "Rollup",
      url: "https://rollupjs.org/guide/en/"
    },
    gulp: {
      image: "images/icons/gulp.png",
      name: "Gulp",
      url: "https://gulpjs.com"
    },
    bash: {
      image: "images/icons/bash.png",
      name: "Bash",
      url: "https://www.gnu.org/software/bash/"
    },
    git: {
      image: "images/icons/git.png",
      name: "GIT",
      url: "https://git-scm.com/"
    },
    mssql: {
      image: "images/icons/sql.png",
      name: "MSSQL",
      url: "https://www.microsoft.com/en-us/sql-server/default.aspx"
    },
    mysql: {
      image: "images/icons/mysql.png",
      name: "MySQL",
      url: "https://www.mysql.com/"
    },
    mongo: {
      image: "images/icons/mongo.png",
      name: "MongoDB",
      url: "https://www.mongodb.com/"
    },
    babylon: {
      image: "images/icons/babylon.png",
      name: "Babylon",
      url: "https://www.babylonjs.com/"
    },
    three: {
      image: "images/icons/three.png",
      name: "Three",
      url: "https://threejs.org/"
    },
    jquery: {
      image: "images/icons/jquery.png",
      name: "jQuery",
      url: "https://jquery.com/"
    },
    zesty: {
      image: "images/icons/zesty.png",
      name: "Zesty CMS",
      url: "https://www.zesty.io/"
    },
    npm: {
      image: "images/icons/npm.png",
      name: "NPM",
      url: "https://www.npmjs.com/package/vue-zoom-scroll"
    },
    aws: {
      image: "images/icons/aws.png",
      name: "AWS",
      url: "https://aws.amazon.com/"
    },
    figma: {
      image: "images/icons/figma.png",
      name: "Figma",
      url: "https://www.figma.com"
    },
    photoshop: {
      image: "images/icons/photoshop.png",
      name: "Photoshop",
      url: "https://www.adobe.com/products/photoshop.html"
    },
    illustrator: {
      image: "images/icons/illustrator.png",
      name: "Illustrator",
      url: "https://www.adobe.com/products/illustrator.html"
    },
    xstate: {
      image: "images/icons/xstatelogo.png",
      name: "Xstate",
      url: "https://xstate.js.org/docs/",
    },
  };